// Auto-generated normalizer for table: LeccionesContenido
export function leccionesContenidoNormalize(row) {
  return {
    idContenido: row.idContenido ?? row.IdContenido ?? row['IdContenido'] ?? 0,
    idLeccion: row.idLeccion ?? row.IdLeccion ?? row['IdLeccion'] ?? 0,
    valor: row.valor ?? row.Valor ?? row['Valor'] ?? '',
    idContenidoTipo: row.idContenidoTipo ?? row.IdContenidoTipo ?? row['IdContenidoTipo'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
